module.exports = __webpack_public_path__ + "img/gallery-icon-01.1a11bbe7.png";